import { createSlice } from '@reduxjs/toolkit';
export const initialState = {
    request: {
        isLoading: false,
    },
    data: [],
    error: null,
};
const jobSliceImpl = createSlice({
    name: 'job',
    initialState,
    reducers: {
        fetchJobData: (state, _action) => {
            state.request.isLoading = true;
            state.error = null;
        },
        storeJobData: (state, action) => {
            state.data = Array.isArray(action.payload) ? action.payload : [];
            state.request.isLoading = false;
            state.error = null;
        },
        jobError: (state, action) => {
            state.error = action.payload;
            state.request.isLoading = false;
        },
    },
});
export const { fetchJobData, storeJobData, jobError } = jobSliceImpl.actions;
// TS4023/TS7056: explicit annotation avoids immer WritableNonArrayDraft leaking into declarations
export const jobSlice = jobSliceImpl;
export default jobSliceImpl.reducer;
